export default __webpack_public_path__ + "static/media/ic_card.56624bc4.png";